import React, { useEffect, useState } from 'react'
import { Form, Modal, Spinner } from 'react-bootstrap'
import Button from 'react-bootstrap/Button'
import Selector from '../ui/Selector'
import { OptionsRes, RuleReq, SelectOption, translatedKeys } from '../types'
import useTheme from '../hooks/useTheme'

interface Props {
	isOpen: boolean
	onClose: () => void
	options: OptionsRes
	save: (data: RuleReq) => void
	isLoading: boolean
}

const AddRuleModal: React.FC<Props> = ({
	isOpen,
	onClose,
	options,
	isLoading,
	save,
}) => {
	const [selectCategory, setSelectCategory] = useState<SelectOption | null>(
		null,
	)
	const [selectCode, setSelectCode] = useState<SelectOption | null>(null)
	const [selectCodeOptions, setSelectCodeOptions] = useState<SelectOption[]>([])
	const [targetCategory, setTargetCategory] = useState<SelectOption | null>(
		null,
	)
	const [targetCode, setTargetCode] = useState<SelectOption | null>(null)
	const [targetCodeOptions, setTargetCodeOptions] = useState<SelectOption[]>([])

	useEffect(() => {
		if (selectCategory) {
			setSelectCodeOptions(
				// @ts-ignore
				Object.keys(options[selectCategory.value]).map((code) => ({
					value: code,
					// @ts-ignore
					label: options[selectCategory.value][code].full_name,
				})),
			)
		}
	}, [selectCategory])

	useEffect(() => {
		if (targetCategory) {
			setTargetCodeOptions(
				// @ts-ignore
				Object.keys(options[targetCategory.value]).map((code) => ({
					value: code,
					// @ts-ignore
					label: options[targetCategory.value][code].full_name,
				})),
			)
		}
	}, [targetCategory])

	const handleSave = () => {
		if (selectCategory && selectCode && targetCategory && targetCode) {
			save({
				selected_field: selectCategory.value,
				field_field_value: selectCode.value,
				related_field: targetCategory.value,
				related_field_value: targetCode.value,
			})
		}
	}
	const theme = useTheme()
	return (
		<Modal
			style={{ '--bs-modal-color': 'var(--bs-body-color)' } as any}
			data-bs-theme={theme}
			centered
			size={'lg'}
			show={isOpen}
			onHide={onClose}
		>
			<div>
				<Modal.Header closeButton>
					<Modal.Title data-bs-theme={theme}>Додати правило</Modal.Title>
				</Modal.Header>

				<Modal.Body>
					<div className="d-flex align-items-center justify-content-center">
						<div style={{ flex: 1 }}>
							<Form.Group className="mb-3">
								<Form.Label>Категорія</Form.Label>
								<Selector
									value={selectCategory}
									onChange={(val) => setSelectCategory(val)}
									options={Object.keys(translatedKeys).map((i) => ({
										value: i,
										// @ts-ignore
										label: translatedKeys[i],
									}))}
								/>
							</Form.Group>
							<Form.Group className="mb-3">
								<Form.Label>Елемент</Form.Label>
								<Selector
									isError={
										selectCodeOptions.length > 0 &&
										!selectCodeOptions.some(
											(i) => i.value === selectCode?.value,
										)
									}
									value={selectCode}
									onChange={(val) => setSelectCode(val)}
									options={selectCodeOptions}
								/>
							</Form.Group>
						</div>
						<div className="m-2">дозволяє лише</div>
						<div style={{ flex: 1 }}>
							<Form.Group className="mb-3">
								<Form.Label>Категорію</Form.Label>
								<Selector
									value={targetCategory}
									onChange={(val) => setTargetCategory(val)}
									options={Object.keys(translatedKeys)
										.filter((i) => i !== selectCategory?.value)
										.map((i) => ({
											value: i,
											// @ts-ignore
											label: translatedKeys[i],
										}))}
								/>
							</Form.Group>
							<Form.Group className="mb-3">
								<Form.Label>Елемент</Form.Label>
								<Selector
									isError={
										targetCodeOptions.length > 0 &&
										!targetCodeOptions.some(
											(i) => i.value === targetCode?.value,
										)
									}
									value={targetCode}
									onChange={(val) => setTargetCode(val)}
									options={targetCodeOptions}
								/>
							</Form.Group>
						</div>
					</div>
				</Modal.Body>

				<Modal.Footer>
					<Button onClick={onClose} variant="secondary">
						Закрити
					</Button>
					<Button
						disabled={
							!(selectCategory && selectCode && targetCategory && targetCode) ||
							(selectCodeOptions.length > 0 &&
								!selectCodeOptions.some(
									(i) => i.value === selectCode?.value,
								)) ||
							(targetCodeOptions.length > 0 &&
								!targetCodeOptions.some(
									(i) => i.value === targetCode?.value,
								)) ||
							isLoading
						}
						onClick={handleSave}
						variant="primary"
					>
						Додати
						{isLoading && (
							<Spinner className="ms-1" animation="border" size="sm" />
						)}
					</Button>
				</Modal.Footer>
			</div>
		</Modal>
	)
}

export default AddRuleModal
